import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GymsService } from '../services/gyms.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class GymListResolver implements Resolve<Observable<string>> {

    constructor(private gymsService: GymsService) { }

    resolve() {
        return this.gymsService.getGyms().catch(() => {
            return Observable.of('error');
        });
    }

}

